import React from 'react';
import {Link, Space, Text, TextLine, TextNumber, TextToRight, Title} from './components';

type AgreementBlock =
    | {type: 'title'; text: string}
    | {type: 'paragraph'; text: string}
    | {type: 'line'; number: string; text: string; strong?: boolean}
    | {type: 'right'; lines: string[]}
    | {type: 'break'}
    | {type: 'space'};

const agreementBlocks: AgreementBlock[] = [
    {type: 'title', text: 'ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ'},
    {
        type: 'paragraph',
        text: 'Настоящее Пользовательское соглашение (далее – Соглашение) определяет условия, на которых Государственное бюджетное учреждение города Москвы «Многофункциональные центры предоставления государственных услуг города Москвы» (ИНН 7731419456, далее – ГБУ МФЦ города Москвы) предлагает Пользователю использовать корпоративную социальную сеть «Мои добрые дела», расположенную в сети «Интернет» по адресу: https://mdd.mos.ru (далее – Сайт).'
    },
    {type: 'title', text: '1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ'},
    {type: 'line', number: '1.1.', text: 'Владелец сайта – ГБУ МФЦ города Москвы.'},
    {
        type: 'line',
        number: '1.2.',
        text: 'Пользователь – физическое лицо, состоящее в трудовых отношениях с ГБУ МФЦ города Москвы, действующее в собственном интересе для публикации историй о своих достижениях, а также примеров решения ситуаций с целью продолжения, поддержания и развития традиций Искреннего сервиса, осуществляющее доступ к Сайту.'
    },
    {
        type: 'line',
        number: '1.3.',
        text: 'Искренний сервис – культура, в основе которой лежит умение смотреть на ситуацию с позиции клиента и решать задачи с точки зрения его интересов, одновременно находя собственную мотивацию.'
    },
    {
        type: 'line',
        number: '1.4.',
        text: 'Пример искреннего сервиса – пример решения ситуации и (или) помощи заявителям и (или) посетителям, связанный с работой ГБУ МФЦ города Москвы, и на который отсутствовало прямое указание в действующих инструкциях ГБУ МФЦ города Москвы.'
    },
    {type: 'line', number: '1.5.', text: 'Администрация сайта – работники ГБУ МФЦ города Москвы, осуществляющие управление Сайтом.'},
    {type: 'line', number: '1.6.', text: 'Контент сайта – любая информация и материалы, публикуемые на Сайте, в том числе Контент пользователя.'},
    {
        type: 'line',
        number: '1.7.',
        text: 'Контент пользователя – любая информация и материалы, направленные Пользователем для опубликования на Сайте, включая, но не ограничиваясь: тексты (в том числе литературные), аудиовизуальные, графические, фотографические материалы, исполнения, фонограммы, изображения, звуки, аудио, музыка, а также сообщения, комментарии, рецензии, другие информация и материалы, публикуемые Пользователем на Сайте.'
    },
    {type: 'line', number: '1.8.', text: 'Правила модерации сайта – условия, которым должен соответствовать Контент сайта.'},
    {type: 'line', number: '1.9.', text: 'Использование сайта:'},
    {
        type: 'line',
        number: '1.9.1.',
        text: 'Доступ к Контенту сайта с правом просмотра информации и материалов, включая, но не ограничиваясь: тексты (в том числе литературные), аудиовизуальные, графические, фотографические материалы, изображения, звуки, аудио, музыка, а также сообщения, комментарии, рецензии, другие информация и материалы, опубликованные на Сайте.'
    },
    {type: 'line', number: '1.9.2.', text: 'Доступ к средствам поиска и навигации Сайта.'},
    {
        type: 'line',
        number: '1.9.3.',
        text: 'Возможность публикации Пользователем информации и материалов, включая, но не ограничиваясь: тексты (в том числе литературные), аудиовизуальные, графические, фотографические материалы, изображения, звуки, аудио, музыка, а также сообщения, комментарии, рецензии, другие информация и материалы, соответствующие законодательству Российской Федерации, Соглашению, в том числе Правилам модерации сайта.'
    },
    {type: 'line', number: '1.9.4.', text: 'Возможность выставления оценок Контенту сайта.'},
    {type: 'title', text: '2. ОБЩИЕ ПОЛОЖЕНИЯ'},
    {
        type: 'line',
        number: '2.1.',
        text: 'Сайт создан как среда, аккумулирующая примеры искреннего сервиса Пользователей, решения ситуаций с целью продолжения, поддержания и развития традиций Искреннего сервиса, которые позволяют:'
    },
    {type: 'line', number: '2.1.1.', text: 'Понять ценность и значимость собственных поступков и разглядеть важное в ежедневной рутине.'},
    {type: 'line', number: '2.1.2.', text: 'Находить решения нестандартных ситуаций.'},
    {type: 'line', number: '2.1.3.', text: 'Вдохновлять Пользователей Сайта на реализацию принципов гуманности и человекоориентированности.'},
    {
        type: 'line',
        number: '2.2.',
        text: 'Пользователь считается присоединившимся к Соглашению, включая Правила модерации сайта, и принявшим его условия в полном объеме, без оговорок и исключений, с момента начала использования Сайта путем активации логина и пароля.'
    },
    {
        type: 'line',
        number: '2.3.',
        text: 'В случае несогласия Пользователя с любыми условиями Соглашения, включая Правила модерации сайта, или его обновлениями, Пользователь не вправе использовать Сайт и обязан прекратить использование Сайта.'
    },
    {type: 'line', number: '2.4.', text: 'Доступ к Сайту предоставляется Пользователю на безвозмездной основе.'},
    {
        type: 'line',
        number: '2.5.',
        text: 'Соглашение, включая Правила модерации Сайта, может быть изменено Владельцем сайта без какого-либо специального уведомления, новая редакция Соглашения, включая Правила модерации сайта, вступает в силу с момента ее размещения по адресу https://mdd.mos.ru, если иное не предусмотрено новой редакцией Соглашения. Действующая редакция Соглашения, включая Правила модерации сайта, размещена на веб-странице по адресу https://mdd.mos.ru/user-agreement. Пользователь несет персональную ответственность за проверку Соглашения, включая Правила модерации сайта, на наличие изменений в нем.'
    },
    {type: 'title', text: '3. ИСПОЛЬЗОВАНИЕ САЙТА'},
    {
        type: 'line',
        number: '3.1.',
        text: 'В целях использования Сайта Пользователю на адрес рабочей электронной почты направляется автоматически сгенерированный логин и пароль.'
    },
    {
        type: 'line',
        number: '3.2.',
        text: 'Пользователь осознает и предоставляет согласие на то, что его фамилия, имя, отчество, должность, наименование структурного подразделения и организация, в которых он работает, могут сопровождать опубликованные материалы в рамках использования Сайта и будут доступны для других Пользователей Сайта.'
    },
    {
        type: 'line',
        number: '3.3.',
        text: 'Указанные на Сайте фамилия, имя, отчество, должность и наименование структурного подразделения и организация Пользователя и иная опубликованная Пользователем информация подлежат отображению для других Пользователей сайта исключительно для целей использования Сайта и персонализации Пользователей.'
    },
    {
        type: 'line',
        number: '3.4.',
        text: 'Обработка предоставляемых Пользователем персональных данных осуществляется Владельцем сайта, Администрацией сайта в соответствии с Федеральным законом от 27 июля 2006 г. № 152-ФЗ «О персональных данных».'
    },
    {
        type: 'line',
        number: '3.5.',
        text: 'Пользователь предоставляет по запросу Владельца сайта, Администрации сайта дополнительную информацию, которая имеет непосредственное отношение к использованию Сайта Пользователем.'
    },
    {
        type: 'line',
        number: '3.6.',
        text: 'Контент сайта не может быть Пользователем скопирован, опубликован, воспроизведен, передан или распространен любым способом, а также размещен в сети «Интернет», без предварительного письменного согласия Владельца сайта, Администрации сайта, за исключением случаев, когда совершение таких действий связано с выполнением трудовых обязанностей.'
    },
    {
        type: 'line',
        number: '3.7.',
        text: 'Направляя Контент пользователя на опубликование на Сайте Пользователь гарантирует, что обладает всеми необходимыми правами на размещаемые материалы.'
    },
    {type: 'line', number: '3.8.', text: 'При использовании Сайта Пользователю недопустимо совершать следующие действия:'},
    {
        type: 'line',
        number: '3.8.1.',
        text: 'Представлять себя за физических лиц, индивидуальных предпринимателей, юридических лиц, органов власти, их представителей и иных третьих лиц (далее – Третьи лица) без достаточных на то прав, в том числе за работника Администрации сайта, Владельца сайта.'
    },
    {
        type: 'line',
        number: '3.8.2.',
        text: 'Обходить навигационную структуру Сайта для получения или попытки получения любой информации, документов или материалов любыми средствами, которые специально не представлены на Сайте.'
    },
    {
        type: 'line',
        number: '3.8.3.',
        text: 'Осуществлять несанкционированный доступ к функциям Сайта, любым другим системам или сетям, относящимся к Сайту.'
    },
    {
        type: 'line',
        number: '3.8.4.',
        text: 'Нарушать права Третьих лиц, в том числе, но не ограничиваясь, на результаты интеллектуальной деятельности и приравненные к ним средства индивидуализации.'
    },
    {type: 'line', number: '3.8.5.', text: 'Использовать Сайт в целях:'},
    {
        type: 'line',
        number: '3.8.5.1.',
        text: 'Опубликования Контента пользователя, который: является незаконным, нарушает любые права Третьих лиц; пропагандирует насилие, жестокость, ненависть и (или) дискриминацию по расовому, национальному, половому, религиозному, социальному признакам; содержит недостоверные сведения, клевету и (или) оскорбления в адрес Третьих лиц.'
    },
    {
        type: 'line',
        number: '3.8.5.2.',
        text: 'Побуждения к совершению противоправных действий, а также содействия лицам, действия которых направлены на нарушение ограничений и запретов, действующих на территории Российской Федерации.'
    },
    {type: 'line', number: '3.8.5.3.', text: 'Нарушения прав несовершеннолетних лиц, в т.ч. причинение им вреда в любой форме.'},
    {
        type: 'line',
        number: '3.8.5.4.',
        text: 'Подстрекательства к любой незаконной деятельности или другой деятельности, нарушающей права Владельца сайта, Администрации сайта, Третьих лиц.'
    },
    {type: 'line', number: '3.8.5.5.', text: 'Распространения информации рекламного характера.'},
    {
        type: 'line',
        number: '3.8.5.6.',
        text: 'Распространения любой конфиденциальной и (или) охраняемой законодательством Российской Федерации информации, включая, но не ограничиваясь, информации о Третьих лицах.'
    },
    {type: 'line', number: '3.8.5.7.', text: 'Иного нарушения нормативных правовых актов Российской Федерации, правовых актов города Москвы.'},
    {
        type: 'line',
        number: '3.9.',
        text: 'Пользователь дает согласие Владельцу сайта, Администрации сайта на внесение любых изменений в текст истории Контента пользователя, в случае несоответствия текста истории Контента пользователя Соглашению, включая Правила модерации сайта, законодательству Российской Федерации.'
    },
    {
        type: 'line',
        number: '3.10.',
        text: 'Пользователь дает согласие Владельцу сайта, Администрации сайта на внесение любых изменений в материалы в составе Контента пользователя, в том числе частичную или полную их замену в составе Контента пользователя, включая, но не ограничиваясь: аудиовизуальные, графические, фотографические материалы, изображения, звуки, аудио, музыку и другие материалы Контента пользователя, без согласования с Пользователем таких изменений, в случае если материалы в составе Контента пользователя имеют низкое качество, а также в случае несоответствия Контента пользователя Соглашению, включая Правила модерации сайта, законодательству Российской Федерации.'
    },
    {
        type: 'line',
        number: '3.11.',
        text: 'Администрация сайта самостоятельно принимает решение о соответствии или несоответствии материалов в Контенте пользователя настоящему Соглашению, включая Правила модерации сайта, и без дополнительного согласования с Пользователем производит корректировку, замену (подходящие по теме и содержанию истории) или удаление материалов в составе Контента пользователя.'
    },
    {type: 'title', text: '4. ПРАВА И ОБЯЗАННОСТИ СТОРОН'},
    {type: 'line', number: '4.1.', text: 'Администрация сайта вправе:', strong: true},
    {
        type: 'line',
        number: '4.1.1.',
        text: 'Без предварительного уведомления Пользователя заблокировать или удалить учетную запись Пользователя, запретить доступ к Сайту, удалить любые материалы без объяснения причин в случае выявления подозрительной активности Пользователя на Сайте, а также если действия Пользователя или размещаемый им Контент пользователя, а также любая иная информация, нарушают законодательство Российской Федерации, условия настоящего Соглашения, в том числе Правила модерации сайта.'
    },
    {
        type: 'line',
        number: '4.1.2.',
        text: 'Без предварительного уведомления Пользователя прекратить и (или) заблокировать доступ к Сайту в случае прекращения действия Сайта либо по техническим причинам.'
    },
    {
        type: 'line',
        number: '4.1.3.',
        text: 'Собирать, анализировать и осуществлять публикацию информации о достижениях Пользователей в целях мотивации на проявление инициативы и поддержание традиций Искреннего сервиса, а также использовать информацию, предоставленную самим Пользователем, в том числе, но не ограничиваясь информацию о персональных данных Пользователя, месте работы, занимаемой должности, а также о действиях Пользователя в качестве показательного примера решения ситуаций в традициях Искреннего сервиса, и делиться такой информацией на Сайте.'
    },
    {
        type: 'line',
        number: '4.1.4.',
        text: 'Направлять Пользователю сообщения, содержащие организационно-техническую информацию о функционировании Сайта и иную информацию, непосредственно связанную с исполнением условий настоящего Соглашения.'
    },
    {type: 'line', number: '4.1.5.', text: 'Производить профилактические работы на Сайте с временным приостановлением его функционирования.'},
    {type: 'line', number: '4.1.6.', text: 'Вносить изменения в структуру и дизайн Сайта.'},
    {type: 'break'},
    {type: 'line', number: '4.2.', text: 'Администрация сайта обязана:', strong: true},
    {
        type: 'line',
        number: '4.2.1.',
        text: 'Обеспечить доступ Пользователя к Сайту после прохождения Пользователем процедуры активации логина и пароля.'
    },
    {
        type: 'line',
        number: '4.2.2.',
        text: 'Осуществлять администрирование Сайта, в том числе поддержание Сайта в работоспособном состоянии и обеспечение его доступности.'
    },
    {type: 'break'},
    {type: 'line', number: '4.3.', text: 'Пользователь вправе:', strong: true},
    {type: 'line', number: '4.3.1.', text: 'Направлять Контент пользователя и примеры искреннего сервиса для публикации на Сайте.'},
    {
        type: 'line',
        number: '4.3.2.',
        text: 'Использовать Сайт и задавать вопросы, относящиеся к использованию Сайта, посредством формы обратной связи, имеющейся на Сайте.'
    },
    {type: 'line', number: '4.3.3.', text: 'Направлять предложения Администрации сайта по улучшению работы Сайта.'},
    {
        type: 'line',
        number: '4.3.4.',
        text: 'Направлять Администрации сайта для опубликования на Сайте тексты (в том числе литературные), аудиовизуальные, графические, фотографические материалы, изображения, звуки, аудио, музыку, а также сообщения, комментарии, рецензии, другие информацию и материалы, размещать комментарии, рецензии, соответствующие законодательству Российской Федерации, Соглашению, в том числе Правилам модерации сайта, выставлять оценки Контенту сайта.'
    },
    {type: 'break'},
    {type: 'line', number: '4.4.', text: 'Пользователь обязан:', strong: true},
    {
        type: 'line',
        number: '4.4.1.',
        text: 'Соблюдать имущественные и неимущественные права авторов и правообладателей при использовании Сайта. Пользователь гарантирует, что Контент пользователя соответствуют требованиям законодательства Российской Федерации.'
    },
    {
        type: 'line',
        number: '4.4.2.',
        text: 'Не предпринимать действий и не оставлять комментарии и записи, которые могут рассматриваться как нарушающие законодательство Российской Федерации или нормы международного права, в том числе в сфере интеллектуальной собственности (включая авторские и смежные права), общепринятые нормы морали и нравственности, а также любых действий, которые приводят или могут привести к нарушению нормальной работы Сайта и сервисов Сайта.'
    },
    {
        type: 'line',
        number: '4.4.3.',
        text: 'Самостоятельно нести ответственность за нарушение интеллектуальных прав Третьих лиц, возмещать причиненные Третьим лицам убытки.'
    },
    {
        type: 'line',
        number: '4.4.4.',
        text: 'Нести ответственность за все действия, их последствия в рамках или с использованием Сайта под учетной записью Пользователя, включая случаи добровольной передачи Пользователем данных для доступа к учетной записи Пользователя третьим лицам. При этом все действия в рамках или с использованием Сайта под учетной записью Пользователя считаются произведенными самим Пользователем, за исключением случаев, когда Пользователь в порядке, предусмотренном пунктом 4.4.5 Соглашения, уведомил Администрацию сайта о несанкционированном доступе к Сайту.'
    },
    {
        type: 'line',
        number: '4.4.5.',
        text: 'Немедленно уведомить Администрацию сайта о любом случае несанкционированного (не разрешенного Пользователем) доступа к Сайту с использованием учетной записи Пользователя и (или) о любом нарушении (подозрениях о нарушении) конфиденциальности своих средств доступа к учетной записи (логина и пароля).'
    },
    {type: 'title', text: '5. ИНТЕЛЛЕКТУАЛЬНЫЕ ПРАВА'},
    {
        type: 'line',
        number: '5.1.',
        text: 'Пользователь предоставляет Владельцу сайта, включая Администрацию сайта, на праве простой (неисключительной) лицензии право использования планируемого к опубликованию или опубликованного Контента пользователя (включая его фрагменты, части, кадры), в том числе в составе сложного произведения, путем: воспроизведения, публичного показа (включая, но не ограничиваясь, демонстрацию на любых площадках, каналах), публичного исполнения, сообщения в эфир и по кабелю, перевода, переработки, доведения до всеобщего сведения, практической реализации проекта, совершения действий для функционирования Сайта в объеме, определяемом функциональностью и архитектурой Сайта, а также всеми разрешенными законом способами. Простая (неисключительная) лицензия предоставляется Пользователем Владельцу сайта, включая Администрацию сайта, на весь срок охраны результатов интеллектуальной деятельности (и приравненных к ним средств индивидуализации), безвозмездно, территория действия – страны всего мира, с правом на сублицензию. Авторское вознаграждение Пользователям сайта и иным лицам, правообладателям и/ или авторам Контента пользователя, Владельцем сайта, Администрацией сайта не выплачивается. Владелец Сайта не предоставляет отчеты об использовании результатов интеллектуальной деятельности или средств индивидуализации. Пользователь выражает согласие на предоставление простой (неисключительной) лицензии и подтверждает ее предоставление путем направления Владельцу сайта, Администрации сайта Контента пользователя посредством функционала Сайта.'
    },
    {
        type: 'line',
        number: '5.2.',
        text: 'В случае, если Контент пользователя содержит результаты интеллектуальной деятельности Третьих лиц (аудиовизуальные произведения, цитаты и т.д.), при направлении Администрации сайта на опубликование Контента пользователя, Пользователь сохраняет знаки авторства или другие уведомления об авторстве, и/или указывает имя автора. В случае, если Пользователю автор неизвестен, Пользователь указывает наименование источника и/ или ссылку на источник, из которого Пользователем взята информация для Контента пользователя.'
    },
    {
        type: 'line',
        number: '5.3.',
        text: 'Текст истории для публикации должен быть авторским и создан Пользователем. Запрещается полное генерирование текста истории нейросетью и другими технологиями искусственного интеллекта.'
    },
    {
        type: 'line',
        number: '5.4.',
        text: 'Допускается создание аудиовизуальных, графических, материалов, изображений, звуков, аудио, музыки, фотографических, аудиовизуальных материалов в составе Контента пользователя с помощью нейросети и других технологий искусственного интеллекта. Во избежание претензий со стороны Третьих лиц при использовании нейросетью и другими технологиями искусственного интеллекта результатов интеллектуальной деятельности Третьих лиц, Пользователь при направлении Контента пользователя на опубликование указывает, что материал в составе Контента пользователя создан технологиями искусственного интеллекта.'
    },
    {
        type: 'line',
        number: '5.5.',
        text: 'Пользователь гарантирует, что он обладает правами на результаты интеллектуальной деятельности или приравненные к ним средства индивидуализации в составе Контента пользователя, направляемого на опубликование Администрации сайта, в объеме, указанном в п. 5.1 настоящего Соглашения.'
    },
    {
        type: 'line',
        number: '5.6.',
        text: 'Владелец сайта, Администрация сайта и Пользователи вправе свободно использовать исключительные права на произведения, перешедшие в общественное достояние.'
    },
    {type: 'title', text: '6. ОТВЕТСТВЕННОСТЬ'},
    {type: 'line', number: '6.1.', text: 'Владелец сайта и Администрация сайта не несут ответственности перед Пользователем или Третьими лицами за:'},
    {
        type: 'line',
        number: '6.1.1.',
        text: 'Прекращение доступа к Сайту в случае нарушения Пользователем положений настоящего Соглашения, иного документа, содержащего условия пользования Сайтом, нормативных правовых актов Российской Федерации, правовых актов города Москвы.'
    },
    {
        type: 'line',
        number: '6.1.2.',
        text: 'Задержки, сбои в процессе совершения коммуникации, любые случаи неполадок в телекоммуникационных, компьютерных, электрических и иных смежных системах, при использовании Сайта Пользователем.'
    },
    {
        type: 'line',
        number: '6.1.3.',
        text: 'Надлежащее функционирование Сайта при отсутствии у Пользователя необходимых технических средств для использования Сайта.'
    },
    {type: 'line', number: '6.1.4.', text: 'Нарушение Пользователем интеллектуальных прав Третьих лиц.'},
    {
        type: 'line',
        number: '6.2.',
        text: 'Пользователь самостоятельно возмещает убытки, возникшие у Третьих лиц в результате нарушения Пользователем прав Третьих лиц, включая, но не ограничиваясь, имущественных и неимущественных прав на результаты интеллектуальной деятельности и приравненные к ним средства индивидуализации.'
    },
    {
        type: 'line',
        number: '6.3.',
        text: 'Владелец сайта и Администрация сайта не являются стороной в спорах между Пользователями и третьими лицами относительно нарушения прав на результаты интеллектуальной деятельности и приравненных к ним средств индивидуализации. Пользователь обязуется разрешать такие споры самостоятельно, без привлечения Владельца сайта и Администрации сайта.'
    },
    {
        type: 'line',
        number: '6.4.',
        text: 'Все возможные споры, вытекающие из настоящего Соглашения или связанные с ним, подлежат разрешению в соответствии с законодательством Российской Федерации по месту нахождения Владельца сайта.'
    },
    {type: 'title', text: '7. ПРОЧИЕ УСЛОВИЯ'},
    {
        type: 'line',
        number: '7.1.',
        text: 'Настоящее Соглашение регулируется и толкуется в соответствии с законодательством Российской Федерации. Вопросы, не урегулированные настоящим Соглашением, подлежат разрешению в соответствии с законодательством Российской Федерации.'
    },
    {
        type: 'line',
        number: '7.2.',
        text: 'Настоящее Соглашение вступает в силу с момента присоединения к нему Пользователя и заключено на неопределенный срок.'
    },
    {
        type: 'line',
        number: '7.3.',
        text: 'Настоящее Соглашение может быть изменено Владельцем сайта, Администрацией сайта в одностороннем порядке. Продолжение использования Сайтом Пользователем после внесения изменений и/или дополнений в настоящее Соглашения означает согласие Пользователя с такими изменениями и (или) дополнениями и присоединение Пользователя к новым условиям Соглашения, включая Правила модерации сайта.'
    },
    {type: 'space'},
    {type: 'right', lines: ['Приложение', 'к Пользовательскому соглашению']},
    {type: 'title', text: 'ПРАВИЛА МОДЕРАЦИИ САЙТА'},
    {
        type: 'paragraph',
        text: 'Правила модерации сайта, расположенного в сети «Интернет» по адресу https://mdd.mos.ru (далее – Сайт), определяют следующие условия, которым должен соответствовать Контент пользователя:'
    },
    {
        type: 'line',
        number: '1.',
        text: 'Контент пользователя должен соответствовать условиям Пользовательского соглашения, включая Правилам модерации сайта.'
    },
    {
        type: 'line',
        number: '2.',
        text: 'Текст истории должен описывать реальные ситуации и поступки, совершенные Пользователем, в одиночку или при участии коллег (с обязательным указанием имени коллеги и (или) ссылки на профиль коллеги).'
    },
    {type: 'line', number: '3.', text: 'Текст истории не должен:'},
    {type: 'line', number: '3.1.', text: 'Содержать информацию, описывающую нарушение закона, норм морали.'},
    {
        type: 'line',
        number: '3.2.',
        text: 'Содержать информацию, описывающую нарушение порядка предоставления государственных услуг работниками ГБУ МФЦ города Москвы.'
    },
    {type: 'line', number: '3.3.', text: 'Быть сгенерирован нейросетью и другими технологиями искусственного интеллекта.'},
    {type: 'line', number: '3.4.', text: 'Являться копией ранее опубликованных материалов Пользователя или Третьих лиц.'},
    {type: 'line', number: '3.5.', text: 'Нарушать интеллектуальные права Третьих лиц.'},
    {
        type: 'line',
        number: '4.',
        text: 'В тексте истории у Пользователя есть возможность выделить слово или часть текста, имеющих основное смысловое значение, при помощи функции форматирования текста (жирный, курсив, подчеркнутый, зачеркнутый).'
    },
    {type: 'line', number: '5.', text: 'Требования к заполнению полей Сайта:'},
    {type: 'line', number: '5.1.', text: 'Поле «Название истории» должно содержать короткий текст (до 150 символов), отражающий суть истории.'},
    {
        type: 'line',
        number: '5.2.',
        text: 'Поле «История» должно содержать текст, который лаконично описывает пример искреннего сервиса Пользователя, в диапазоне от 250 до 2000 символов.'
    },
    {
        type: 'line',
        number: '5.3.',
        text: 'Прикрепляемое к публикации «Фото» - это изображение, подходящее по теме и содержанию истории, в высоком качестве, в формате *.jpg или *.png и размером не более 5 Мб (далее – Изображение). Изображение может быть загружено с устройства Пользователя или выбрано из имеющегося на Сайте банка изображений. История может содержать не более одного Изображения.'
    },
    {
        type: 'line',
        number: '5.4.',
        text: 'Прикрепляемое к публикации «Видео» - это видеофайл, подходящий по содержанию истории (с #КлёвоеСобрание), в высоком качестве, в формате MP4 или WebM (допустимые кодеки видеофайла: AV1, VP8, VP9, H.264), с горизонтальной ориентацией видеоизображения и размером не более 20 Мб (далее – Видео). Видео загружается с устройства Пользователя. История может содержать не более одного Видео.'
    },
    {
        type: 'line',
        number: '5.5.',
        text: 'Выбор «Хештегов» - это указание ключевого слова или нескольких слов, облегчающих поиск историй по теме или содержанию, из имеющегося на Сайте перечня.'
    },
    {
        type: 'line',
        number: '6.',
        text: 'Текст истории, а также иные материалы в составе Контента пользователя, включая, но не ограничиваясь, аудиовизуальные, графические, фотографические материалы, исполнения, фонограммы, изображения, звуки, аудио, музыка, а также сообщения, комментарии, рецензии, другие информация и материалы не должны содержать рекламную информацию, включая, но не ограничиваясь, наименование брендов (наименование банков, магазинов, ресторанов, одежды, обуви, электроники и прочее), а также водяных знаков.'
    },
    {
        type: 'line',
        number: '7.',
        text: 'Текст истории, а также иные материалы в составе Контента пользователя, включая, но не ограничиваясь, аудиовизуальные, графические, фотографические материалы, исполнения, фонограммы, изображения, звуки, аудио, музыка, а также сообщения, комментарии, рецензии, другие информация и материалы, не должны содержать персональные данные участников истории (адрес регистрации, адрес фактического проживания, дата рождения и прочее), за исключением лиц, указанных в п. 2 настоящих Правил модерации Сайта.'
    },
    {
        type: 'line',
        number: '8.',
        text: 'Текст истории, а также иные материалы в составе Контента пользователя, включая, но не ограничиваясь, аудиовизуальные, графические, фотографические материалы, исполнения, фонограммы, изображения, звуки, аудио, музыка, а также сообщения, комментарии, рецензии, другие информация и материалы, направленные Пользователем для опубликования на Сайте, подлежат обязательной проверке на соответствие Соглашению, в том числе Правилам модерации сайта, и публикуются на Сайте без корректировок только в случае соответствия действующему Соглашению, включая Правила модерации сайта. В случае несоответствия материалов в составе Контента пользователя Соглашению, включая Правилам модерации, материалы могут быть скорректированы Администрацией сайта, не допущены до публикации на Сайте или удалены с Сайта.'
    },
    {
        type: 'line',
        number: '9.',
        text: 'Изображения, имеющие низкое разрешение и качество, недостаточное для различения объектов, изображенных на них, подлежат корректировке (замене) на Изображения, подходящие по теме и содержанию истории, или удалению, на усмотрение Администрации сайта.'
    },
    {
        type: 'line',
        number: '10.',
        text: 'Видео, имеющие низкое разрешение и качество, недостаточное для различения объектов, изображенных на них, подлежат удалению с Сайта.'
    },
    {
        type: 'line',
        number: '11.',
        text: 'Администрация сайта оставляет за собой право удалять Контент без объяснения причин в случае поступления заявлений, претензий о нарушении прав на результаты интеллектуальной деятельности и приравненных к ним средств индивидуализации. Пользователь, разместивший такой Контент, уведомляется о его удалении и несет полную ответственность перед Третьими лицами за возможные последствия нарушения их прав.'
    }
];

const renderText = (text: string) => {
    const urlPattern = /(https:\/\/mdd\.mos\.ru(?:\/user-agreement)?)/g;

    return text.split(urlPattern).map((part, index) =>
        part.startsWith('https://mdd.mos.ru') ? (
            <Link key={`${part}-${index}`} href={part}>
                {part}
            </Link>
        ) : (
            part
        )
    );
};

const renderAgreementBlock = (block: AgreementBlock, index: number) => {
    if (block.type === 'title') {
        return <Title key={index}>{block.text}</Title>;
    }

    if (block.type === 'paragraph') {
        return <Text key={index}>{renderText(block.text)}</Text>;
    }

    if (block.type === 'right') {
        return (
            <TextLine key={index}>
                <TextToRight>
                    {block.lines.map((line, lineIndex) => (
                        <React.Fragment key={line}>
                            {lineIndex > 0 && <br />}
                            {line}
                        </React.Fragment>
                    ))}
                </TextToRight>
            </TextLine>
        );
    }

    if (block.type === 'break') {
        return <br key={index} />;
    }

    if (block.type === 'space') {
        return <Space key={index} />;
    }

    return (
        <TextLine key={index}>
            <TextNumber>{block.number}</TextNumber>
            <Text>{block.strong ? <b>{renderText(block.text)}</b> : renderText(block.text)}</Text>
        </TextLine>
    );
};

export const V3Agreement = () => {
    return <Text pt={4}>{agreementBlocks.map(renderAgreementBlock)}</Text>;
};
